import { useCallback, useState } from 'react';
import { updateHideSummary } from '@alltrails/reviews/utils/reviewSummaryRequests';
import type { TrailId } from '@alltrails/types/TrailId';

type Args = {
  trailId?: TrailId;
  initialHideSummary?: boolean;
  initialReviewSummary?: string;
};

const useReviewSummary = ({ trailId, initialHideSummary, initialReviewSummary }: Args) => {
  const [isLoading, setIsLoading] = useState(false);
  const [hideReviewSummary, setHideReviewSummary] = useState(initialHideSummary);
  const [reviewSummary, setReviewSummary] = useState(initialReviewSummary);

  const onToggleHideReviewSummary = useCallback(() => {
    if (!trailId) {
      console.error('Trail ID is required to update hide summary');
      return;
    }

    const newHideReviewSummary = !hideReviewSummary;
    setIsLoading(true);
    updateHideSummary(trailId, newHideReviewSummary)
      .then(response => {
        setHideReviewSummary(newHideReviewSummary);
        setReviewSummary(response?.review_summary);
        setIsLoading(false);
      })
      .catch((e: Error) => {
        console.error(`Failed to update hide summary: ${e?.message}`);
        setIsLoading(false);
      });
  }, [trailId, hideReviewSummary]);

  return {
    isLoading,
    hideReviewSummary,
    reviewSummary,
    onToggleHideReviewSummary
  };
};

export default useReviewSummary;
